import { applyMiddleware, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import ravenMiddleware from '../../core/js/middleware/raven';

import { constructTealiumMiddleware, coreTags } from '../../core/js/middleware/analytics';
import { storeLogger } from '../../core/js/middleware/logger';

import coreApp from '../../core/js/reducers/coreApp';
import { initialState as coreInitialState } from '../../core/js/store';

const initialState = Object.assign({}, coreInitialState, {
    core: Object.assign({}, coreInitialState.core, {
        pageType: 'stores'
    })}
);

export function initStore() {
    const tealiumMiddleware = constructTealiumMiddleware([coreTags()]);
    const sagaMiddleware = createSagaMiddleware();
    const createStoreWithMiddleware = applyMiddleware(
        storeLogger('Legacy'),
        ravenMiddleware,
        tealiumMiddleware,
        sagaMiddleware
    )(createStore);

    return Object.assign({}, createStoreWithMiddleware(coreApp, initialState), { runSaga: sagaMiddleware.run });
}
